const reducer = (state = 'All', action) =>{
    switch(action.type){
        case "setRebateFrequency": 
            return action.payload;
        default: 
            return state;
    }
}

export default reducer;